import React, { useEffect, useState } from "react";
import { Banner, Reviews } from "../../components";
import SectionOne from "./SectionOne";
import Description from "../about/Description";
import SectionTwo from "./SectionTwo";
import SectionFAQ from "./SectionFAQ";
import LookingFor from "./LookingFor";
import { useParams } from "react-router-dom";
import { services } from "../../data";
import PageMeta from "../../seo/PageMeta";
import { buildServiceSchema, buildFaqSchema } from "../../seo/serviceSchema";

const Service = () => {
  const { id } = useParams();

  const [service, setService] = useState({
    id: "",
    name: "",
    image: "",
    tagline: "",
    description: "",
    faq: [],
    tasks: [],
  });

  useEffect(() => {
    window.scroll({ behavior: "smooth", top: 0 });
    const service = services.filter((item) => item.id === id)[0];
    setService(service);
  }, [id]);

  const jsonLd = service.name
    ? [buildServiceSchema(service), buildFaqSchema(service.faq)].filter(Boolean)
    : undefined;

  return (
    <div className="flex flex-col items-center w-full">
      <PageMeta
        title={service.name || "Our Services"}
        description={
          service.description ||
          "Explore Clear Choice Cleaning Services' professional cleaning solutions across Melbourne."
        }
        path={`/services/${id}`}
        image={service.image || "/assets/images/banners/services.webp"}
        jsonLd={jsonLd}
      />
      <Banner heading={service.name} page={service.id} />
      <SectionOne data={service} />
      {service.id === "home-cleaning" && <SectionTwo />}
      <SectionFAQ data={service.faq} />
      <LookingFor />
      <Reviews />
      <Description />
    </div>
  );
};

export default Service;
